export enum Presence {
  Presence = 'Présent',
  AbsenceJustified = 'Absence justifiée',
  AbsenceNotJustified = 'Absence non justifiée',
  WaitingForRecontact = 'Attente de recontact',
  AbsenceToJustify = 'Absence à justifier',
  NotNeededPresence = 'Présence non requise',
}

export const labelsByPresence: Map<Presence, string> = new Map<Presence, string>(
  Object.keys(Presence).map((x: string) => [x, Presence[x]] as [Presence, string]),
);
